import React, { Fragment, useEffect, useState, useRef } from "react";
// import { useSelector, useDispatch } from 'react-redux';
import {
  loginUser,
  logoutUser,
  GetCaptcha,
  SetLoginError,
} from "../../common/actions/userActions";
import connect from "react-redux/lib/connect/connect";
import store from "../../common/store";
import { checkLoginIdstr, isEmpty } from "../../common/cores";
import Link from "react-router-dom/Link";
import Headbar from "./Headbar";
import { isMobile } from "../../utils/utils";

const Login = (props) => {
  const { loginError, captchaData } = props.user;
  // console.log(props)
  const [loginIdErr, setLoginIdErr] = useState("");
  const [loginPwdErr, setLoginPwdErr] = useState("");
  const [captchaErr, setCaptchaErr] = useState("");

  const [inputs, setInputs] = useState({
    loginId: "",
    loginPwd: "",
    captcha: "",
  });
  const loginRef = useRef();
  const { loginId, loginPwd, captcha } = inputs;
  let captchaId = !isEmpty(captchaData) && captchaData.captchaId;
  //   const dispatch = useDispatch();

  const onChange = (e) => {
    const { value, name } = e.target; // 우선 e.target 에서 name 과 value 를 추출
    setInputs({
      ...inputs, // 기존의 input 객체를 복사한 뒤
      [name]: value, // name 키를 가진 값을 value 로 설정
    });
    setLoginIdErr("");
    setLoginPwdErr("");
    setCaptchaErr("");
    if (!isEmpty(loginError)) {
      props.SetLoginError("");
    }
  };

  const onReset = () => {
    setInputs({
      loginId: "",
      loginPwd: "",
      captcha: "",
    });
  };
  const onCaptcha = () => {
    store.dispatch(GetCaptcha()).then(() => {});
  };

  useEffect(() => {
    onCaptcha();
    loginRef.current.focus();
  }, []);

  const captchaRefresh = () => {
    onCaptcha();
  };

  const onSubmit = (e, type) => {
    setInputs({
      loginId: loginId,
      loginPwd: loginPwd,
      captcha: "",
    });
    e.preventDefault();
    if (checkLoginIdstr(loginId)) {
      setLoginIdErr(
        isEmpty(window.lang["아이디에 특수문자를 포함할수 없습니다."])
          ? "아이디에 특수문자를 포함할수 없습니다."
          : window.lang["아이디에 특수문자를 포함할수 없습니다."]
      );
      return;
    } else if (isEmpty(loginId) && isEmpty(loginPwd) && isEmpty(captcha)) {
      setLoginIdErr(
        isEmpty(window.lang["아이디를 입력해 주세요."])
          ? "아이디를 입력해 주세요."
          : window.lang["아이디를 입력해 주세요."]
      );
      setLoginPwdErr(
        isEmpty(window.lang["비밀번호를 입력해 주세요."])
          ? "비밀번호를 입력해 주세요."
          : window.lang["비밀번호를 입력해 주세요."]
      );
      setCaptchaErr(
        isEmpty(window.lang["보안문자를 입력해주세요"])
          ? "보안문자를 입력해주세요"
          : window.lang["보안문자를 입력해주세요"]
      );
      return;
    } else if (isEmpty(loginId)) {
      setLoginIdErr(
        isEmpty(window.lang["아이디를 입력해 주세요."])
          ? "아이디를 입력해 주세요."
          : window.lang["아이디를 입력해 주세요."]
      );
      return;
    } else if (isEmpty(loginPwd)) {
      setLoginPwdErr(
        isEmpty(window.lang["비밀번호를 입력해 주세요."])
          ? "비밀번호를 입력해 주세요."
          : window.lang["비밀번호를 입력해 주세요."]
      );
      return;
    } else if (isEmpty(captcha)) {
      setCaptchaErr(
        isEmpty(window.lang["보안문자를 입력해주세요"])
          ? "보안문자를 입력해주세요"
          : window.lang["보안문자를 입력해주세요"]
      );
      return;
    } else {
      let params = {
        loginId,
        loginPwd,
        captchaId,
        captcha,
      };
      store.dispatch(loginUser(params)).then(() => {
        setLoginIdErr("");
        setLoginPwdErr("");
        setCaptchaErr("");
        props.history.push("/");
      });
    }
  };

  const onEnter = (e) => {
    // e.preventDefault();

    if (e.key === "Enter") {
      // e.preventDefault();
      onSubmit(e);
    }
  };

  useEffect(() => {
    if (props.isAuthenticated) props.logoutUser();
  }, []);

  useEffect(() => {}, [props.language]);

  return (
    <Fragment>
      <div id="layoutBody" style={{ paddingTop: "0px" }}>
        <div className="wrapper  lang_ko" id="bodyTemplate">
          <div id="contentTheme"></div>
          <Headbar />
          <div
            className="container-fluid login_section"
            style={{ paddingTop: isMobile() && "5px" }}
          >
            <div id="theme_p_login" className="special_bg">
              <div className="loginwrap">
                <div className="loginbox" id="loginForm" onKeyDown={onEnter}>
                  <span className="icon_mem"></span>
                  <p className="title">
                    {isEmpty(window.lang["유저 로그인"])
                      ? "유저 로그인"
                      : window.lang["유저 로그인"]}
                  </p>
                  <input
                    type="text"
                    name="loginId"
                    className="login_input id"
                    placeholder={
                      isEmpty(window.lang["아이디를 입력해 주세요."])
                        ? "아이디를 입력해 주세요."
                        : window.lang["아이디를 입력해 주세요."]
                    }
                    id="user_id_in"
                    ref={loginRef}
                    onChange={onChange}
                  />
                  <span
                    className="color-danger font-bold m-d-block m-w-100"
                    style={{
                      fontSize: "1rem",
                      display: isEmpty(loginError) && "block",
                      height: "20px",
                    }}
                  >
                    &ensp;{isEmpty(loginIdErr) ? " " : loginIdErr}
                  </span>
                  <input
                    type="password"
                    name="loginPwd"
                    className="login_input password"
                    placeholder={
                      isEmpty(window.lang["비밀번호를 입력해 주세요."])
                        ? "비밀번호를 입력해 주세요."
                        : window.lang["비밀번호를 입력해 주세요."]
                    }
                    onChange={onChange}
                  />
                  <span
                    className="color-danger font-bold m-w-100"
                    style={{
                      fontSize: "1rem",
                      display: isEmpty(loginError) && "block",
                      height: "20px",
                    }}
                  >
                    &ensp;{isEmpty(loginPwdErr) ? " " : loginPwdErr}
                  </span>
                  <input
                    className="login_input"
                    name="captcha"
                    type="text"
                    value={captcha}
                    maxLength={4}
                    placeholder={
                      isEmpty(window.lang["보안문자를 입력해주세요"])
                        ? "보안문자를 입력해주세요"
                        : window.lang["보안문자를 입력해주세요"]
                    }
                    inputMode="text"
                    onChange={onChange}
                  />
                  <div className="captcha_input">
                    <div className="captcha_img">
                      <img
                        style={{ height: "50px", width: "100%" }}
                        src={captchaData.image}
                        alt=""
                      />
                    </div>
                    <button
                      className="margin-left-5 captcha_refresh font-normal"
                      onClick={captchaRefresh}
                    >
                      <i className="fa fa-refresh"></i>
                    </button>
                  </div>
                  <span
                    className="color-danger font-bold m-w-100"
                    style={{
                      fontSize: "1rem",
                      display: "block",
                      height: "20px",
                    }}
                  >
                    {isEmpty(captchaErr) ? " " : captchaErr}
                  </span>

                  <div className="bot_btn">
                    <button
                      className="bt_login btn_login"
                      id="btnLogin"
                      langkey="new_theme.login.login"
                      onClick={onSubmit}
                    >
                      {isEmpty(window.lang["로그인"])
                        ? "로그인"
                        : window.lang["로그인"]}
                    </button>
                    {/* <button className="btn_telegram" id="getQrlogin" value="">텔레그렘 QR코드
                                            로그인</button>

                                        <div id="qrArea">
                                            <img id="qrImg" style={{ display: 'inline' }} />
                                            <div id="qrCenterIconArea">
                                                <img id="qrCenterIcon"
                                                    src="/r/front/img/comm/ico_telegram.png" />
                                            </div>
                                        </div> */}

                    <ul>
                      <li>
                        <span
                          className=""
                          langkey="new_theme.login.join_membership"
                        >
                          {isEmpty(window.lang["아직 회원이 아니신가요?"])
                            ? "아직 회원이 아니신가요?"
                            : window.lang["아직 회원이 아니신가요?"]}
                        </span>
                        <Link to="/Register" className="" langkey="button.join">
                          {isEmpty(window.lang["가입하기"])
                            ? "가입하기"
                            : window.lang["가입하기"]}
                        </Link>
                      </li>
                      {/* <li id="go_telegram" link-data="demo_telegram_id">
                                                <span className="social telegram"><span className=""
                                                    style={{ paddingLeft: '1rem', color: '#fff', fontWeight: 'bold', fontSize: '15px' }}
                                                    langkey="new_theme.login.telegram_cs_connection">텔레그램
                                                    고객센터 연결</span></span>
                                            </li>
                                            <li id="go_kakao" link-data="demo_cacaotalk_id">
                                                <span className="social kakao"><span className=""
                                                    style={{ paddingLeft: '1rem', color: '#3e2723', fontWeight: 'bold', fontSize: '15px' }}
                                                    langkey="new_theme.login.kakaotalk_cs_connection">카카오톡
                                                    고객센터 연결</span></span>
                                            </li>
                                            <li id="go_twitter" link-data="demo_twitter_id">
                                                <span className="social twitter"><span className=""
                                                    style={{ paddingLeft: '1rem', color: '#fff', fontWeight: 'bold', fontSize: '15px' }}
                                                    langkey="new_theme.login.twitter_cs_connection">트위터
                                                    고객센터 연결</span></span>
                                            </li> */}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="temporary_spa_section" style={{ display: "none" }}></div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.user.isAuthenticated,
  user: state.user,
  language: state.more.language,
});

export default connect(mapStateToProps, {
  loginUser,
  logoutUser,
  SetLoginError,
})(Login);



// WEBPACK FOOTER //
// ./src/components/Layout/Login.js